<template>
    <div v-if="user && settings && !user.impersonating && !is_ops_login">
        <OnboardingProfileModal />
        <OnboardingPasswordModal />
    </div>
</template>

<script>
    import Cookies from "js-cookie";
    import OnboardingProfileModal from "./OnboardingProfileModal.vue";
    import OnboardingPasswordModal from "./OnboardingPasswordModal.vue";
    import Global from "../../mixins/Global";

    export default {
        name: "OnboardingModals",

        mixins: [Global],

        components: {
            OnboardingPasswordModal,
            OnboardingProfileModal
        },

        data() {
            return {
                user,
                is_ops_login: false
            };
        },

        mounted() {
            const cookie = Cookies.get("is_ops_login");

            if (cookie !== undefined) {
                this.is_ops_login = true;
            }
        }
    };
</script>